import React from 'react';
import {
  addPathToList,
  File_type_image,
  getSubCategoryId,
  No_results_image,
  Search_results,
  select_recipient,
  Upload_assets,
  where_your_customer_search,
} from '../../../utils/DictionaryManagementUtils';
import FullPagePanel from '../General/FullPagePanel';
import UploadMenu from '../Upload/UploadMenu';

//= ========================================================================

const DefaultSearchResults = ({
  globJSON,
  onConfigChanged,
  selectedScreen,
  onStepPressed,
  onGotoEdit,
  language,
}) => {
  const editTextList = [
    'no_results',
    'search_contact_hint',
    'translate_to',
  ];
  const listObject = [
    {
      subHeadline: No_results_image,
      fileId: 'configurations/launch/keyboard/no_results_image',
    },
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({
    sub_category: myScreen.sub_category,
    duplication_number: 0,
  });
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={select_recipient}
      panelSubHeadline={Search_results}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/recipient/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/recipient/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={where_your_customer_search}
      isHollow
      language={language}
    >
      <UploadMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={Upload_assets}
        details={File_type_image}
        listObject={listObject}
      />

    </FullPagePanel>
  );
};

export default DefaultSearchResults;
